import { formatDate, SIZE_DASH } from "../../lib/format";
import { Kebab } from "../ui/Kebab";
import { FolderIcon } from "./icons";
import type { FolderDTO } from "../../lib/api/types";

interface FolderRowProps {
  folder: FolderDTO;
  onOpen: (id: string) => void;
  disabled: boolean;
}

export function FolderRow({ folder, onOpen, disabled }: FolderRowProps) {
  return (
    <div className="flex min-h-row items-center gap-3 border-b border-surface-border px-gutter py-2 hover:bg-surface-muted">
      <FolderIcon className="h-5 w-5 shrink-0 text-folder" />
      <div className="min-w-0 flex-1">
        <button
          type="button"
          disabled={disabled}
          onClick={() => onOpen(folder.id)}
          className="block max-w-full truncate text-left text-body font-medium text-text hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 disabled:cursor-not-allowed disabled:no-underline"
        >
          {folder.name}
        </button>
        <div className="mt-0.5 flex gap-2 text-meta text-text-muted sm:hidden">
          <span>{formatDate(folder.createdAt)}</span>
          <span aria-hidden="true">·</span>
          <span>{SIZE_DASH}</span>
        </div>
      </div>
      <div className="hidden w-40 shrink-0 text-body text-text-muted sm:block">
        {formatDate(folder.createdAt)}
      </div>
      <div className="hidden w-24 shrink-0 text-right text-body text-text-muted sm:block">
        {SIZE_DASH}
      </div>
      <div className="flex w-8 shrink-0 justify-end">
        <Kebab disabled={disabled} label={`Actions for ${folder.name}`}>
          {() => (
            <div className="px-3 py-2 text-body text-text-muted">No actions</div>
          )}
        </Kebab>
      </div>
    </div>
  );
}
